import React from "react";
import { useTranslation } from "react-i18next";

function LanguageSwitcher() {
	const { i18n } = useTranslation();

	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
	};

	return (
		<select
			value={i18n.language}
			defaultValue={i18n.language}
			onChange={(e) => changeLanguage(e.target.value)}
			className="px-2 h-8 w-16 bg-transparent text-sm border rounded cursor-pointer text-violet-50 border-violet-50 outline-none transition-all">
			<option
				value="ms"
				label="BM"
				className="text-violet-950">
				Bahasa Melayu
			</option>
			<option
				value="en"
				label="EN"
				className="text-violet-950">
				English
			</option>
			<option
				value="zh"
				label="中文"
				className="text-violet-950">
				中文
			</option>
		</select>
	);
}

export default LanguageSwitcher;
